import {
  Component,
  ViewEncapsulation,
  OnInit,
  Inject, OnDestroy
} from '@angular/core';

import {
  DOCUMENT
} from '@angular/common';
import * as moment from 'moment';
import {
  ApiService
} from '../services/api';
import {HttpParams} from '@angular/common/http';
import {PlotBand} from '@progress/kendo-angular-charts';
import {UserContext} from '../services/user-context';
import {Title} from '@angular/platform-browser';

// google key AIzaSyDTS1raZELPmXV9kuTXgBvkYoldsSqonhQ
@Component({
  selector: 'app-dashboard',
  encapsulation: ViewEncapsulation.None,
  templateUrl: 'dashboard.template.html',
  styleUrls: [
    './dashboard.style.scss'
  ]
})
export class DashboardComponent implements OnInit, OnDestroy {
  start: Date = moment().subtract(30, 'days').toDate();
  end: Date = moment().toDate();
  locations = 0;
  lat = 35.268107;
  lng = -90.744821;
  zoom = 4;

  public conversionBands: PlotBand[] = [{
    from: 0, to: 30, color: '#ccc', opacity: .6
  }, {
    from: 30, to: 100, color: '#ccc', opacity: .3
  }];

  public quotaBands: PlotBand[] = [{
    from: 0, to: 2, color: '#ccc', opacity: .6
  }, {
    from: 2, to: 5, color: '#ccc', opacity: .3
  }];

  public conversion: any[] = [[0, 30]];
  public quota: any[] = [[0, 2]];

  public ranges = [
    {range: 'day', title: 'Today'},
    {range: 'wtd', title: 'This Week'},
    {range: 'mtd', title: 'This Month'},
    {range: 'qtd', title: 'This Quarter'},
    {range: 'ytd', title: 'This Year'},
    {range: 'week', title: 'Last 7 Days'},
    {range: 'month', title: 'Last 30 Days'},
    {range: 'quarter', title: 'Last 3 Months'},
    {range: 'year', title: 'Last 12 Months'}
  ];

  public mapStyles = [
    {elementType: 'geometry', stylers: [{color: '#aec3cb'}]},
    {elementType: 'labels.text.stroke', stylers: [{'visibility': 'off'}]},
    {elementType: 'labels.text.fill', stylers: [{color: '#888888'}]},
    {
      featureType: 'administrative.locality',
      elementType: 'labels.text.fill',
      stylers: [{color: '#555555'}]
    },
    {
      featureType: 'poi',
      elementType: 'labels.text.fill',
      stylers: [{'visibility': 'off'}]
    },
    {
      featureType: 'poi.park',
      elementType: 'geometry',
      stylers: [{color: 'transparent'}]
    },
    {
      featureType: 'poi.park',
      elementType: 'labels.text.fill',
      stylers: [{color: 'transparent'}]
    },
    {
      featureType: 'road',
      elementType: 'geometry',
      stylers: [{color: '#c0d7e0'}]
    },
    {
      featureType: 'road',
      elementType: 'geometry.stroke',
      stylers: [{color: '#bbdefb'}]
    },
    {
      featureType: 'road',
      elementType: 'labels.text.fill',
      stylers: [{color: '#9ca5b3'}]
    },
    {
      featureType: 'road.highway',
      elementType: 'geometry',
      stylers: [{color: '#c0d7e0'}]
    },
    {
      featureType: 'road.highway',
      elementType: 'geometry.stroke',
      stylers: [{color: '#c0d7e0'}]
    },
    {
      featureType: 'road.highway',
      elementType: 'labels.text.fill',
      stylers: [{color: '#81d4fa'}]
    },
    {
      featureType: 'transit',
      elementType: 'geometry',
      stylers: [{color: '#2f3948'}]
    },
    {
      featureType: 'transit.station',
      elementType: 'labels.text.fill',
      stylers: [{color: 'transparent'}]
    },
    {
      featureType: 'water',
      elementType: 'geometry',
      stylers: [{color: '#e3e8ee'}]
    },
    {
      featureType: 'water',
      elementType: 'labels.text.fill',
      stylers: [{color: 'transparent'}]
    },
    {
      featureType: 'water',
      elementType: 'labels.text.stroke',
      stylers: [{color: 'transparent'}]
    }
  ];

  public settings = {range: 'month', salesUnit: 'volume'};
  public summary = {commission: '0', revenue: '0', sales: '0', net: '0', processed: '0', conversion: '0', average: '0'};
  public revenue = [];
  public revenueSeries: any[] = [];
  public commissionSeries: any[] = [];
  public volumeSeries: any[] = [];
  public averageSeries: any[] = [];

  private series: any[] = [];
  private sessionSeries: any[] = [];
  private sessionCategories: string[] = [];
  private categories: string[] = [];
  private markers: any[] = [];
  private services: any[] = [];

  constructor(@Inject(DOCUMENT) private document: Document, private api: ApiService, private title:Title, public userContext: UserContext) {

    this.refreshSummary();
    this.refreshSalesTrend();
    this.refreshMap();
    this.refreshSessionsTrend();
  }

  public filterFieldChanged(): void {
    this.refreshSummary();
    this.refreshMap();
    this.refreshSessionsTrend();
  }

  public labelContent(e: any): string {
    return e.category;
  }

  public ngOnInit(): void {
    if( this.userContext.account ) {
      this.title.setTitle(`${this.userContext.account.name} Link`);
    }
  }

  public ngOnDestroy(): void {
  }

  public refreshSummary(): void {
    console.log("Refreshing summary");
    this.api.get<any>(`/summary`, new HttpParams()
      .append('start', moment(this.start).toISOString())
      .append('end', moment(this.end).toISOString()))
      .subscribe(result => {
        if ( Array.isArray(result.summary) && result.summary.length) {
          this.summary = result.summary[0];
        }

        this.revenueSeries = [];
        this.commissionSeries = [];
        this.volumeSeries = [];
        this.averageSeries = [];

        result.trend.map((day) => {
          this.revenueSeries.push(day.revenue || 0);
          this.commissionSeries.push(day.commission || 0);
          this.volumeSeries.push(day.sales || 0);
          this.averageSeries.push(day.average || 0);
        });
      });
  }

  public refreshMap(): void {
    this.api.get<any>(`/sales/map`, new HttpParams()
      .append('start', moment(this.start).toISOString())
      .append('end', moment(this.end).toISOString()))
      .subscribe(result => {
        this.markers = (result || []).filter((marker) => marker.latitude && marker.longitude);
        // console.log("Got map elements: " + JSON.stringify(result));
      });
  }

  public refreshSessionsTrend(): void {
    this.api.get<any>('/sales/sessions')
      .subscribe(result => {
        const dates: string[] = [];
        const series: any[] = [];

        result.map((day) => {
          dates.push(day._id);
        });

        let data = result.map(d => d.quantity);
        series.push({name: "Sessions", data: data});

        this.sessionCategories = dates;
        this.sessionSeries = series;
      });
  }


  public refreshSalesTrend(): void {
    this.api.get<any>('/sales')
      .subscribe(result => {
        const dates: string[] = [];
        const sales: any = {};
        const totals = {};
        const series: any[] = [];

        result.map((day) => {
          dates.push(day._id);
        });

        let data = result.map(d => d.quantity);
        series.push({name: "Products", data: data});

        this.categories = dates;
        this.series = series;
      });
  }
}
